import AxiosConfig from '../../../config/AxiosConfig';

const useSystemCancel = () => {
  const systemCancel = async (update) => {
    try {
      const res = AxiosConfig.create('put', '/system/cancel/')
        .call(update)
        .getResponseData();
      return res;
    } catch (err) {
      console.error('Failed to cancel system:', err);
      throw new Error(`System cancel failed: ${err.message}`);
    }
  };
  return { systemCancel };
};

export default useSystemCancel;
